@if (listing && listing.models && listing.models.length) {
<div>
    <!-- slider -->
    <swiper [slidesPerView]="[2,2,4,4][client.sizeId]"
            [scrollbar]="{dragSize: 48}"
            [spaceBetween]="[16,16,8,8][client.sizeId]"
            [freeMode]="true"
            class="p-b-7 p-b-4-s p-b-4-m">
        @for (model of listing.models; track $index; let i = $index) {
        <ng-template swiperSlide>
            <product class="w-12 left"
                     [model]="model"
                     [listPosition]="i"
                     [listId]="listId"
                     [listName]="listName"
                     [klevuRecommendationId]="klevuRecommendationId"
                     [acClickCode]="acClickCode"
                     [gtmImpressionTrack]="{productId: model.id, position: i+1, list: 'Related products', numberOfResults: listing.models.length}"
                     [gtmTrackProductClick]="{productId: model.id, position: i+1, list: 'Related products'}"
                     [forceOneImage]="true"
                     [inCarousel]="true"
                     [canShowTieredPrice]="true"></product>
        </ng-template>
        }
    </swiper>
</div>
}